import React, { useState, useEffect, useMemo } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { useAuth } from "../../context/auth";
import jsPDF from "jspdf";

import { FaTrash } from 'react-icons/fa';

const Userdetails = () => {
  const [users, setUsers] = useState([]);
  const [userType, setUserType] = useState("all"); // 'all', 'google', 'manual'
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [auth] = useAuth();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [manualUsers, setManualUsers] = useState([]);
  const [googleUsers, setGoogleUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true);
        const [manualResponse, googleResponse] = await Promise.all([
          axios.get("https://api.makeeasydocuments.com/api/auth/allusers", {
            headers: { Authorization: `Bearer ${auth.token}`},
          }),
          axios.get("https://api.makeeasydocuments.com/api/auth/getgoogle"),
        ]);
  
        console.log("Manual Users API Response:", manualResponse.data);
        console.log("Google Users API Response:", googleResponse.data);
  
        if (manualResponse.data.success && Array.isArray(manualResponse.data.users)) {
          const manualData = manualResponse.data.users.map((user) => ({
            ...user,
            type: "Manual",
          }));
  
          const googleData = Array.isArray(googleResponse.data)
            ? googleResponse.data.map((user) => ({
                ...user,
                type: "Google",
              }))
            : [];
  
          console.log("Processed Manual Users:", manualData);
          console.log("Processed Google Users:", googleData);
  
          setManualUsers(manualData);
          setGoogleUsers(googleData);
          setFilteredUsers([...manualData, ...googleData]);
        } else {
          console.error("Unexpected API Response Format");
        }
      } catch (error) {
        console.error("Failed to fetch users", error);
        setError("Failed to fetch users");
      } finally {
        setLoading(false);
      }
    };
  
    fetchUsers();
  }, [auth.token]);
  



  const handleFilter = (type) => {
    setUserType(type);
    setCurrentPage(1); // Reset pagination
  
    if (type === "google") {
      console.log("Filtering Google Users:", googleUsers);
      setFilteredUsers([...googleUsers]);  // Ensure a new array is assigned
    } else if (type === "manual") {
      console.log("Filtering Manual Users:", manualUsers);
      setFilteredUsers([...manualUsers]);
    } else {
      console.log("Showing All Users");
      setFilteredUsers([...manualUsers, ...googleUsers]);
    }
  };
  



  const confirmDelete = (userId) => {
    setUserToDelete(userId);
    setShowDeleteConfirm(true);
};

const handleDelete = async (userId, type) => {
    try {
        const endpoint = type === 'Google' ? 'googledelete' : 'userdelete';
        const response = await axios.delete(`https://api.makeeasydocuments.com/api/auth/${endpoint}/${userId}`, {
            headers: { Authorization: `Bearer ${auth.token}` }
        });
        if (response.data.success) {
            if (type === 'Google') {
                setGoogleUsers(googleUsers.filter(user => user._id !== userId));
            } else {
                setManualUsers(manualUsers.filter(user => user._id !== userId));
            }
            setShowDeleteConfirm(false);
            setUserToDelete(null);
        }
    } catch (error) {
        console.error("Error deleting user:", error);
    }
};


const allUsers = [...manualUsers, ...googleUsers];
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = useMemo(
    () => filteredUsers.slice(indexOfFirstItem, indexOfLastItem),
    [filteredUsers, indexOfFirstItem, indexOfLastItem]
  );
  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);

  



  const generatePDF = (type) => {
    const doc = new jsPDF();
    doc.text(`${type === "Google" ? "Google" : "All Manual"} Users Report`, 20, 20);
    let y = 30;
    const data = type === "Google" ? googleUsers : manualUsers;
    data.forEach((user, index) => {
      doc.text(`${index + 1}. ${user.name || user.firstname}  -  ${user.email}  --  ${user.contact}`, 20, y);
      y += 10;
    });
    doc.save(`${type === "Google" ? "google_users" : "manual_users"}_report.pdf`);
  };







  return (
    <div className="flex-1 overflow-auto relative z-10">
      <h2 className="mt-3 mx-3 mb-3 font-bold text-3xl border border-black text-blue-800 text-center bg-gray-300 p-2 rounded-lg shadow-sm">
        User Details
      </h2>

      <div className="my-4 flex gap-4 justify-center">
        <button onClick={() => generatePDF("All")} className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-green-700">
          Download All Manual PDF
        </button>

        <button onClick={() => generatePDF("Google")} className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-green-700">
          Download Google Users PDF
        </button>
     
        {["all", "google", "manual"].map((type) => (
          <button
            key={type}
            onClick={() => {
              setUserType(type);
              setCurrentPage(1);
              setFilteredUsers(
                type === "google" ? [...googleUsers] : type === "manual" ? [...manualUsers] : [...manualUsers, ...googleUsers]
              );
            }}
            className={`px-4 py-2 rounded-md ${userType === type ? "bg-blue-700" : "bg-blue-500 text-white"}`}
          >
            {type.charAt(0).toUpperCase() + type.slice(1)}
          </button>
        ))}
      </div>

      <div className="mx-5 mt-4">
        {loading ? (
          <p>Loading users...</p>
        ) : error ? (
          <p className="text-red-500">{error}</p>
        ) : (
          <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} className="overflow-x-auto">
            <table className="w-full min-w-[700px] mx-auto bg-white shadow-md rounded-lg">
              <thead>
                <tr className="bg-gray-300">
                  <th className="px-4 py-2 border">Sr No</th>
                  <th className="px-4 py-2 border">Name</th>
                  <th className="px-4 py-2 border">Email</th>
                  
                  <th className="px-4 py-2 border">Contact</th>
                  <th className="px-4 py-2 border">Type</th>
                  
                  <th className="px-4 py-2 border">Action</th>
                </tr>
              </thead>
              <tbody>
        {filteredUsers.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map((user, index) => (
          <tr key={user._id} className="bg-white border-b hover:bg-gray-100">
            <td className="px-4 py-2 border text-center">{(currentPage - 1) * itemsPerPage + index + 1}</td>
            <td className="px-4 py-2 border text-center">{user.name || `${user.firstname} ${user.lastname}`}</td>
            <td className="px-4 py-2 border text-center">{user.email}</td>
            
            <td className="px-4 py-2 border text-center">{user.contact}</td>
            <td className="px-4 py-2 border text-center">{user.type}</td>
            <td className="px-4 py-2 border text-center">
              <FaTrash 
                className="cursor-pointer text-red-500  rounded-md  justify-center items-center hover:bg-red-100" 
                onClick={() => confirmDelete(user._id)} 
              />
            </td>
          </tr>
        ))}
      </tbody>
            </table>
          </motion.div>
        )}
      </div>
      <div className="flex justify-center mt-4">
                <button onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}>Prev</button>
                {[...Array(totalPages)].map((_, i) => (
                    <button key={i} onClick={() => setCurrentPage(i + 1)}>{i + 1}</button>
                ))}
                <button onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}>Next</button>
            </div>
            {showDeleteConfirm && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
    <div className="bg-white rounded-lg p-6 max-w-xs w-full text-center shadow-lg">
        <h3 className="text-lg font-bold text-gray-800">Confirm Deletion</h3>
        <p className="text-sm text-gray-600 my-4">Are you sure you want to delete this user?</p>
        <div className="flex justify-center space-x-4">
            <button 
                onClick={() => handleDelete(userToDelete, allUsers.find(user => user._id === userToDelete).type)} 
                className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-md transition"
            >
                Delete
            </button>
            <button 
                onClick={() => setShowDeleteConfirm(false)} 
                className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-md transition"
            >
                Cancel
            </button>
        </div>
    </div>
</div>

            )}
        
      
    </div>
  );
};

export default Userdetails;